export enum Permission {
  View = 'delivery_orchestration.view',
  Modify = 'delivery_orchestration.modify',
}
